import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductCollectionRealTimeInventory } from "@store/Services/ProductServiceV2"; // Poolcorp Custom Code

replaceInChain(chain, RequestDataFromApi, async props => {
    if (!getSettingsCollection(props.getState()).productSettings.showInventoryAvailability) {
        return;
    }

    try {
        props.apiResult = await getProductCollectionRealTimeInventory(props.apiParameter); // Poolcorp Custom import
    } catch (error) {
        logger.warn(`Failed to load inventory data: ${error}`);
        props.error = error;
    }
});
